module.exports = __webpack_public_path__ + "static/media/empty-state-view-details.956cae51.svg";